export default "__VITE_ASSET__C_haPLw7__"